module.exports = __webpack_public_path__ + "52eae949463627d9dd649241ca045ffe.png";